import DataTileDefault from './DataTile';
export const DataTile = DataTileDefault;
export type { DataTileProps, DataTileItem, DataTileConfig, DataTileFieldConfig } from './DataTile';
